/**
 * Copyright (C) 2022 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React, { ReactElement } from 'react';
import merge from 'lodash/merge';
import { bpsToUnitString } from '../../../../../utils/DataRateUtils';
import { addCustomMetadataGetterToSeries, getDataRateChartTooltipFormatter } from '../ChartDataFormatterUtils';
import { ChartItemKeys, chartSeriesContent, ChartType } from '../ChartSeriesItems';
import ChartWrapper from './ChartWrapper';
import { defaultChartOptions, withTerminalHistoryChartHOCAndNoDataAvailableHOC } from './WithTerminalHistoryChartHOC';

interface FlDataRateChartProps {
  index: number;
  text: string;
  id: string;
  chart: Highcharts.Chart | null;
  children: ReactElement | ReactElement[];
}

const FlDataRateChart = (props: FlDataRateChartProps) => {
  const { index, text, id, children } = props;
  const chartName = text;

  return (
    <ChartWrapper name={chartName} id={id} index={index} chartType={ChartItemKeys.flDataRate}>
      {children}
    </ChartWrapper>
  );
};


export const getLineChartDefaultOptions = (
  yAxisTitle: string,
  isPowerChart?: boolean,
  yAxisFormater?: (value: number) => string,
  xAxisFormater?: (value: number) => string,
) => {
  const defaultOptions = addCustomMetadataGetterToSeries(
    {
      ...defaultChartOptions(ChartType.line),
    },
    ' / ',
  );
  return merge(defaultOptions, {
    yAxis: [
      {
        // when undefined, min is auto set by highcharts
        min: isPowerChart ? undefined : 0,
        labels: {
          formatter(): string {
            // @ts-ignore
            return yAxisFormater ? yAxisFormater(this.value) : bpsToUnitString(this.value);
          },
        },
        title: {
          text: yAxisTitle,
        },
      },
      {
        labels: {
          formatter(): string {
            // @ts-ignore
            return xAxisFormater ? xAxisFormater(this.value) : bpsToUnitString(this.value);
          },
        },
        title: {
          text: '',
        },
        opposite: true,
      },
    ],
    tooltip: {
      pointFormatter: getDataRateChartTooltipFormatter,
    },
    plotOptions: { series: { custom: { useDetailedLabelSymbols: true } } },
  });
};

export default withTerminalHistoryChartHOCAndNoDataAvailableHOC(
  FlDataRateChart,
  ChartType.line,
  getLineChartDefaultOptions('FL'),
  chartSeriesContent[ChartItemKeys.flDataRate],
  'flRateGapSec',
);
export { FlDataRateChart as FlDataRateChartComponent };
